import React from "react";
import { Card, CardBody } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { useTranslation } from "react-i18next";

const ProcedureBreakdownChart = ({ chartData = {} }) => {
  const { t } = useTranslation();

  const labels = chartData.labels && chartData.labels.length > 0
    ? chartData.labels
    : ["Root Canal", "Crown & Bridge", "Extraction", "Scaling", "Implants", "Orthodontics"];

  const series = chartData.series && chartData.series.length > 0
    ? chartData.series
    : [35, 22, 18, 15, 12, 8];

  const options = {
    chart: {
      type: "donut",
      fontFamily: "inherit"
    },
    labels: labels,
    colors: ["#556ee6", "#34c38f", "#f1b44c", "#50a5f1", "#f46a6a", "#74788d", "#e83e8c"],
    legend: {
      position: "bottom",
      fontSize: "11px",
      markers: { radius: 12 }
    },
    plotOptions: {
      pie: {
        donut: {
          size: "68%",
          labels: {
            show: true,
            total: {
              show: true,
              label: t("Total Cases"),
              fontSize: "12px",
              color: "#74788d",
              formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0)
            }
          }
        }
      }
    },
    dataLabels: { enabled: false },
    stroke: { width: 2, colors: ["#fff"] }
  };

  return (
    <Card className="border-0 shadow-sm mb-4 h-100">
      <CardBody>
        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
          <div className="d-flex align-items-center">
            <div className="avatar-xs me-2">
              <span className="avatar-title rounded bg-soft-info text-info font-size-16">
                <i className="bx bx-pie-chart-alt" />
              </span>
            </div>
            <div>
              <h5 className="card-title mb-0 font-size-15 fw-bold">
                {t("Procedures Distribution")}
              </h5>
              <div className="text-muted font-size-11">
                {t("Volume by dental procedure type")}
              </div>
            </div>
          </div>
        </div>

        <div className="apex-charts d-flex justify-content-center">
          <ReactApexChart options={options} series={series} type="donut" height={280} />
        </div>
      </CardBody>
    </Card>
  );
};

export default ProcedureBreakdownChart;
